/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import activationLinkDialogTemplate from './activation-link.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */


/*@ngInject*/
export default function AddUserController($scope, $translate, $mdDialog, $state, $stateParams, $document, $q,
                                          toast, types, userService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {};

        vm.activationMethods = [
            {
                value: 'displayActivationLink',
                name: 'user.display-activation-link'
            },
            {
                value: 'sendActivationMail',
                name: 'user.send-activation-mail'
            }
        ];

        vm.userActivationMethod = 'displayActivationLink';

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add($event) {
        var sendActivationMail = false;
        if (vm.userActivationMethod == 'sendActivationMail') {
            sendActivationMail = true;
        }
        switch (vm.entityTableConfiguration.scope) {
            case types.scope.provider:
                if ($stateParams.providerId) {
                    vm.entity.providerId = {
                        entityType: types.entityType.provider,
                        id: $stateParams.providerId
                    };
                }
                break;
            case types.scope.customer:
                if ($stateParams.customerId) {
                    vm.entity.customerId = {
                        entityType: types.entityType.customer,
                        id: $stateParams.customerId
                    };
                }
                break;
            case types.scope.subCustomer:
                if ($stateParams.subCustomerId) {
                    vm.entity.subCustomerId = {
                        entityType: types.entityType.subCustomer,
                        id: $stateParams.subCustomerId
                    };
                }
                break;
        }
        userService.saveUser(vm.entity, sendActivationMail).then(function success(entity) {
            vm.entity = entity;
            $scope.theForm.$setPristine();
            if (vm.userActivationMethod === 'displayActivationLink') {
                userService.getActivationLink(vm.entity.id.id).then(
                    function success(activationLink) {
                        displayActivationLink($event, activationLink).then(
                            function() {
                                $mdDialog.hide();
                            }
                        );
                    }
                );
            } else {
                $mdDialog.hide();
                toast.showSuccess($translate.instant('user.activation-email-sent-message'));
            }
        });
    }

    function displayActivationLink($event, activationLink) {
        var deferred = $q.defer();
        $mdDialog.show({
            controller: 'ActivationLinkDialogController',
            controllerAs: 'vm',
            templateUrl: activationLinkDialogTemplate,
            locals: {
                activationLink: activationLink
            },
            parent: angular.element($document[0].body),
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(function () {
            deferred.resolve();
        });
        return deferred.promise;
    }

}


// WEBPACK FOOTER //
// ./src/app/user/add-user.controller.js